import type { FC } from "react";
import { uniqueId } from "lodash";

interface ExtraFieldProps {
  hidden: boolean;
  fields: Array<{ label: string; value: string }>;
}

const ExtraField: FC<ExtraFieldProps> = ({ hidden, fields }) => {
  if (hidden) return;

  return (
    <div>
      {fields.map((field) => (
        <div key={`extra-field-${uniqueId()}`}>
          <div className="text-xs text-gray-500">{field.label}</div>
          <div className="text-sm break-words">{field.value}</div>
        </div>
      ))}
    </div>
  );
};

export default ExtraField;
